import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { NavigationService } from '@app/navigation/navigation.service';
import { LoggerService } from '../logger/logger.service';
import { AuthenticationService } from './authentication.service';
import { AuthorizationService } from './authorization.service';

const log = new LoggerService('AUTHENTICATION GUARD');

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router, 
    private authenticationService: AuthenticationService
  ) {
    
  }


  async canActivate() {
    //log.debug('[canActivate] called.');
    const userIsLoggedIn = await this.authenticationService.isLoggedIn();
    //this.router.resetConfig(this.navigationService.generateRouterConfiguration());
    
    if (userIsLoggedIn) {
      //log.debug('[canActivate] El usuario ha sido autenticado.');
      return true;
    }
    
    //log.debug('canActivate] Usuario no autenticado, redireccionando al home...');
    this.router.navigate(['home'], { replaceUrl: true });
    return false;
  }
}
